import type { SVGAttributes } from 'react'

export type Props = SVGAttributes<SVGElement>

export function Svg({
  stroke = 'currentColor',
  strokeWidth = '1.5',
  width = '24',
  height = '24',
  ...props
}: SVGAttributes<SVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      role="img"
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    />
  )
}
